





import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import moment from 'moment';
import { post, get } from '@/unite/api';
import Dialog from '@/components/dialog.vue';
@Component({
  components: { SearchPaginationTable, Dialog }
})
export default class CollectionRecords extends Vue {
  mounted() {
    this.autoRefesh();
  }
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  visible: boolean = false;
  timer: any;
  pageData: any = {
    url: '/back/v1/sms/list',
    isSearch: true, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      number: '',
      page_index: 1,
      page_num: 10
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'number', // 字段
        tip: '手机号码',
        placeholder: '请输入手机号码'
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '导出sms',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: false,
      border: true,
      expandShow: false,
      optionShow: true,
      tableRowClassName: function(tableData: any) {
        if (tableData.row.card_status === 3) {
          return 'success3-row';
        }
        return '';
      },
      header: [
        // {
        //   prop: 'id',
        //   label: 'ID',
        //   width: '70'
        // },
        {
          prop: 'Receiver',
          label: '接收号码',
          width: '130'
        },
        {
          prop: 'Sender',
          label: '发送方'
        },
        {
          prop: 'depart_name',
          label: '部门'
        },
        {
          prop: 'group_name',
          label: '分组'
        },
        {
          prop: 'mode',
          // _prop: 'mode',
          label: '模式'
          // status: {
          //   1: 'WebSocket',
          //   2: 'HTTP',
          //   3: 'RPC'
          // }
        },
        {
          prop: 'unified_name',
          label: '规则定义名称'
        },
        {
          prop: 'unified_type',
          label: '规则定义类型'
        },
        {
          prop: 'create_at',
          label: '创建时间',
          type: 'time'
        },
        {
          prop: 'create_at',
          label: '接收时间',
          type: 'time'
        }
      ],
      expand: [],
      optionWidth: 120,
      option: [
        {
          name: '查看内容',
          methods: 'find',
          type: 'success',
          role: function(row: any) {
            return 1;
          }
        }
      ]
    } // table
  };
  private handleClick(methods: string, row: any) {
    if (methods === 'find') {
      get(`/back/v1/sms/info?id=${row.id}`, {}).then(d => {
        // @ts-ignore
        this.$msgbox(d.Content.Content, `SMS内容`, {
          confirmButtonText: '确定'
        });
      });
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
  }
  // 30秒刷新
  autoRefesh() {
    this.timer = setInterval(() => {
      // @ts-ignore
      this.$refs.table.getData();
    }, 30 * 1000);
  }
  destroyed() {
    clearInterval(this.timer);
  }
}
